import Button from '../../../components/base/Button';

export default function ServicesSection() {
  const handleCall = () => {
    window.location.href = 'tel:0491121950';
  };

  const services = [
    {
      title: 'Full Interior & Exterior Detail',
      price: 'from $250',
      originalPrice: 'from $280',
      image: 'https://static.readdy.ai/image/cd116a5342bbace3e474cedd10298d09/03bda6ec0e00a1b86ccd8263c750667b.png',
      features: [
        'Complete exterior wash & wax',
        'Interior deep clean & vacuum',
        'Leather conditioning',
        'Window cleaning inside & out',
        'Tire shine & wheel cleaning',
        'Dashboard & trim protection'
      ]
    },
    {
      title: 'Interior Only Detail',
      price: 'from $180',
      originalPrice: 'from $210',
      image: 'https://static.readdy.ai/image/cd116a5342bbace3e474cedd10298d09/461a48d28032ac1baed68f11f0642e86.png',
      features: [
        'Deep vacuum all surfaces',
        'Leather cleaning & conditioning',
        'Dashboard & trim cleaning',
        'Door panel detailing',
        'Seat cleaning & protection',
        'Interior window cleaning'
      ]
    },
    {
      title: 'Exterior Only Detail',
      price: 'from $120',
      originalPrice: 'from $150',
      image: 'https://static.readdy.ai/image/cd116a5342bbace3e474cedd10298d09/4f7acabefb8142224ebf1cd0fdb4eb06.jpeg',
      features: [
        'Complete exterior wash',
        'Paint protection wax',
        'Wheel cleaning & polish',
        'Tire shine application',
        'Exterior trim restoration',
        'Exterior window cleaning'
      ]
    },
    {
      title: 'Maintenance Detail',
      price: 'from $170',
      image: 'https://static.readdy.ai/image/cd116a5342bbace3e474cedd10298d09/eb00a183eeef8a42eeae62733907742c.png',
      features: [
        'Exterior wash & wax',
        'Interior vacuum & wipe down',
        'Window cleaning',
        'Tire shine',
        'Quick interior tidy',
        'Basic protection application'
      ],
      membersOnly: true
    },
    {
      title: 'Ceramic Coating',
      price: 'from $1100',
      image: 'https://public.readdy.ai/ai/img_res/4a4648e6534b6066c7c07fd3fb8bc57b.jpg',
      features: [
        'Paint correction preparation',
        'Premium ceramic coating application',
        '2-5 year protection',
        'Hydrophobic properties',
        'Enhanced gloss & depth',
        'Easy maintenance'
      ]
    },
    {
      title: 'Starlights',
      price: 'from $800',
      image: 'https://static.readdy.ai/image/cd116a5342bbace3e474cedd10298d09/792bac155a7fbd002630f6c0052b142b.png',
      features: [
        'Custom starlight design',
        'Premium fiber optic installation',
        'LED controller system',
        'Professional fitting',
        'Warranty included',
        'Multiple color options'
      ]
    }
  ];

  return (
    <section id="services" className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-white mb-4">
            <strong>Our Services</strong>
          </h3>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Professional mobile detailing services delivered to your location throughout Melbourne
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-900 rounded-xl shadow-lg overflow-hidden border border-gray-800 hover:shadow-xl transition-shadow duration-300">
              <div className="relative">
                <img 
                  src={service.image}
                  alt={`${service.title} - Mobile car detailing Melbourne`}
                  title={`${service.title} - Starlight Motors Melbourne`}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-teal-500 text-white px-3 py-1 rounded-full font-semibold">
                  {service.originalPrice && (
                    <div className="flex flex-col items-end">
                      <span className="text-xs line-through opacity-75">{service.originalPrice}</span>
                      <span>{service.price}</span>
                    </div>
                  )}
                  {!service.originalPrice && service.price}
                </div>
                {service.originalPrice && (
                  <div className="absolute top-4 left-4 bg-red-500 text-white px-3 py-1 rounded-full font-semibold text-sm">
                    Special Deal
                  </div>
                )}
                {service.membersOnly && (
                  <div className="absolute top-4 left-4 bg-yellow-500 text-white px-3 py-1 rounded-full font-semibold text-sm">
                    Members Only
                  </div>
                )}
              </div>
              
              <div className="p-6">
                <h4 className="text-xl font-bold text-white mb-4">
                  <strong>{service.title}</strong>
                </h4>
                
                <ul className="space-y-2 mb-6">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start">
                      <i className="ri-check-line text-teal-400 mt-1 mr-2 flex-shrink-0"></i>
                      <span className="text-sm text-gray-300">{feature}</span>
                    </li>
                  ))}
                </ul>
                
                <Button 
                  onClick={handleCall}
                  className="w-full"
                  data-product-shop
                >
                  Call Now
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
